// extracted by mini-css-extract-plugin
module.exports = {"sent-collaborator-nft-requests-list":"SentCollaboratorNftUploadRequests_sent-collaborator-nft-requests-list__2a_PJ"};